import { isCustomDimension, isDimension, isMetric, isTableCalculation, } from '@lightdash/common';
export const isPivotRowValue = (item) => item !== undefined && (isMetric(item) || isTableCalculation(item));
export const resolvePivotRowFieldIds = ({ selectedItemIds, itemsMap, pivotDimensions, columnOrder, pivotRows, }) => {
    if (!selectedItemIds || !itemsMap)
        return [];
    const selectedItemIdSet = new Set(selectedItemIds);
    const pivotDimensionSet = new Set(pivotDimensions ?? []);
    const defaultRowDimensions = columnOrder.filter((fieldId) => {
        const item = itemsMap[fieldId];
        return (selectedItemIdSet.has(fieldId) &&
            !pivotDimensionSet.has(fieldId) &&
            item !== undefined &&
            (isDimension(item) || isCustomDimension(item)));
    });
    // Unpivoted tables follow columnOrder; a stale pivotRows must not override it
    if (pivotRows === undefined || pivotDimensionSet.size === 0)
        return defaultRowDimensions;
    const configuredFields = pivotRows.filter((fieldId) => {
        const item = itemsMap[fieldId];
        return (selectedItemIdSet.has(fieldId) &&
            !pivotDimensionSet.has(fieldId) &&
            item !== undefined &&
            (isDimension(item) ||
                isCustomDimension(item) ||
                (pivotDimensionSet.size > 0 && isPivotRowValue(item))));
    });
    return [
        ...configuredFields,
        ...defaultRowDimensions.filter((fieldId) => !configuredFields.includes(fieldId)),
    ];
};
export const shouldDisableMetricsAsRows = ({ metricsAsRows, selectedItemIds, rowFieldIds, itemsMap, }) => {
    if (!metricsAsRows || !selectedItemIds || !itemsMap)
        return false;
    const rowFieldIdSet = new Set(rowFieldIds);
    return !selectedItemIds.some((fieldId) => !rowFieldIdSet.has(fieldId) && isPivotRowValue(itemsMap[fieldId]));
};
